var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNoshow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0003 7.99935C14.0003 11.3131 11.314 13.9993 8.00033 13.9993C4.68662 13.9993 2.00033 11.3131 2.00033 7.99935C2.00033 4.68564 4.68662 1.99935 8.00033 1.99935C11.314 1.99935 14.0003 4.68564 14.0003 7.99935ZM15.3337 7.99935C15.3337 12.0494 12.0504 15.3327 8.00033 15.3327C3.95024 15.3327 0.666992 12.0494 0.666992 7.99935C0.666992 3.94926 3.95024 0.666016 8.00033 0.666016C12.0504 0.666016 15.3337 3.94926 15.3337 7.99935ZM6.80506 5.86128C6.54471 5.60093 6.1226 5.60093 5.86225 5.86128C5.6019 6.12163 5.6019 6.54374 5.86225 6.80409L7.05752 7.99935L5.86225 9.19461C5.6019 9.45496 5.6019 9.87707 5.86225 10.1374C6.1226 10.3978 6.54471 10.3978 6.80506 10.1374L8.00033 8.94216L9.19559 10.1374C9.45594 10.3978 9.87805 10.3978 10.1384 10.1374C10.3987 9.87707 10.3987 9.45496 10.1384 9.19461L8.94313 7.99935L10.1384 6.80409C10.3987 6.54374 10.3987 6.12163 10.1384 5.86128C9.87805 5.60093 9.45594 5.60093 9.19559 5.86128L8.00033 7.05654L6.80506 5.86128Z",
    fill: "#E51717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoshow);
export default __webpack_public_path__ + "static/media/ic_noshow.faeb4a19a70399d58fbbc0ac834483ef.svg";
export { ForwardRef as ReactComponent };